import axios from 'axios'
import store from '../store'



// 获取配置图片
export function getConferenceImage (data) {
    let brandId = localStorage.getItem('brand_id');
    console.log(brandId)
    return axios({
      url: process.env.BASE_URL + '/ordering_system_admin/conferenceinfo/getConferenceImage',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      data: {
        'data': JSON.stringify({
          brandId: store.state.user.selectedBrandId || brandId,
          conferenceId: store.state.user.conferenceId,
          ...data
        })
      }
    })
}

// 显示管理后台活动分享邀请主副标题
export function showPartnerInviteShareTitle (data) {
    let brandId = localStorage.getItem('brand_id');
    console.log(brandId)
    return axios({
      url: process.env.BASE_URL + '/ordering_system_admin/conferencepartner/showPartnerInviteShareTitle',
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'post',
      data: {
        'data': JSON.stringify({
          userId: brandId,
          conferenceId: store.state.user.selectedBrandId || brandId,
          ...data
        })
      }
    })
}

// 查看文章
export function getarticle(data) {
  let brandId = localStorage.getItem('brand_id');
	return axios({
		url: process.env.BASE_URL + '/ordering_system_admin/userarticle/getarticle',
		method: 'post',
		data: {
			// "articleType":"511","articleUserId":"435","conferenceId":"44"
			conferenceId: store.state.user.conferenceId,
			articleUserId: brandId,
			...data
		}
	})
}



// WEBPACK FOOTER //
// ./src/api/config.js